import React, { createContext, useState, useEffect, useContext } from "react";

// Create Context
const FussstatusGrafikContext = createContext();

// Provider Component
export const FussstatusGrafikProvider = ({ children }) => {
  const initialData = {
    medRight: [],
    medLeft: [],
    latRight: [],
    latLeft: [],
    plRight: [],
    plLeft: [],
    dorsRight: [],
    dorsLeft: [],
  };

  const [data, setData] = useState(() => {
    const saved = localStorage.getItem("fussstatusGrafik");
    return saved ? JSON.parse(saved) : initialData;
  });

  // Persist to localStorage whenever data changes
  useEffect(() => {
    localStorage.setItem("fussstatusGrafik", JSON.stringify(data));
  }, [data]);

  // Helper: check for duplicate {loc, befund} in a list
  const isDuplicate = (list, loc, befund) =>
    list.some((item) => item.loc === loc && item.befund === befund);

  // Save a new finding – use key like 'medRight', 'plLeft', etc.
  const saveFinding = (key, loc, befund) => {
    if (!loc || !befund) return;

    setData((prev) => {
      const currentList = prev[key] || [];
      if (isDuplicate(currentList, loc, befund)) return prev;

      return {
        ...prev,
        [key]: [...currentList, { loc, befund }],
      };
    });
  };

  // Delete a finding by index – use key like 'medRight', 'plLeft', etc.
  const deleteFinding = (key, index) => {
    setData((prev) => {
      const currentList = prev[key] || [];
      return {
        ...prev,
        [key]: currentList.filter((_, i) => i !== index),
      };
    });
  };

  // Clear everything (useful for new patient / reset)
  const clearFussstatusGrafik = () => {
    setData(initialData);
    localStorage.removeItem("fussstatusGrafik");
  };

  return (
    <FussstatusGrafikContext.Provider
      value={{
        data,                  
        saveFinding,      
        setData,     
        deleteFinding,         
        isDuplicate,          
        clearFussstatusGrafik,
      }}
    >
      {children}
    </FussstatusGrafikContext.Provider>
  );
};

// Custom hook
export const useFussstatusGrafik = () => {
  const context = useContext(FussstatusGrafikContext);
  if (!context) {
    throw new Error("useFussstatusGrafik must be used within FussstatusGrafikProvider");
  }
  return context;
};